import React,{useEffect} from 'react'
import { useStateValue } from './StateProvider'
import "./Checkout.css";
import CheckoutProduct from "./CheckoutProduct";
import Subtotal from "./Subtotal";
import axios from "./axios"

function Checkout() {
    const [{basket,user},dispatch]=useStateValue();
    useEffect(() => {
        const updatePrices = async () => {
          try {
            const productIds = basket.map((item) => item.id);
            const response=axios({
              url:'/products/get/update-price',
              method:'post',
              headers: { "Content-Type": "application/json" },
              data:productIds
            })
            const latestPrices = await response;
    
            await latestPrices.data.forEach(({ _id, price,stock }) => {
              const basketItem = basket.find((item) => item.id === _id);
              basket.forEach((item,id)=>{
                if(stock>0){
                  if(item.count>stock){
                    dispatch({ type: "UPDATE_PRODUCT_PRICE", payload: { _id, newPrice: price,newStock:stock,count:stock }});
                  }
                  else{
                    dispatch({ type: "UPDATE_PRODUCT_PRICE", payload: { _id, newPrice: price,newStock:stock,count:item.count }});
                  }
                }
              })
              if(basketItem&&stock<1){
                dispatch({ type: "UPDATE_PRODUCT_PRICE", payload: { _id, newPrice: price,newStock:stock,count:stock<1&&0} });
              }
            });
          } catch (error) {
            console.error("Error fetching or updating prices:", error);
          }
        };
    
        if (basket.length > 0) {
          updatePrices();
        }
      }, []);
    useEffect(()=>{
        const user=JSON.parse(localStorage.getItem("user"))

        localStorage.setItem(`cart.${user}`,JSON.stringify(basket))
    },[basket])
    const emptyBasket=()=>{
        dispatch({
            type:"EMPTY_BASKET"
        })
    }
    return<div className="checkout">
        <div className="checkoutProduct__left">
        <img className="checkout__ad" src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._C8423492668_.jpg" alt=""/>
        
        {basket?.length===0?(
            <div>
                <h4>Hello, {user?.email}{user?'':'Guest'}
                </h4>
                <h2>Your Shopping basket is empty</h2>
                <p>You have no items in basket. To buy one or more click on "Add to basket " next to the item</p>
            </div>
        ):(
            <div className='text-center'>
                
                <h2 className="checkout__title">Your Shopping basket</h2>
                <button onClick={emptyBasket}>Empty Basket</button>
                {basket?.map(item=>(
                    <CheckoutProduct key={item.id}
                    id={item.id}
                    title={item.title}
                    image={item.image}
                    price={item.price}
                    rating={item.rating}
                    count={item.count}
                    stock={item.stock}
                    />
                ))}
            </div>
        )}
        </div>
        {basket.length>0&&(
            <div className="checkout__right">
                <Subtotal/>
            </div>

        )}
        </div>;
}

export default Checkout
